const BASE_URI = 'https://admin.winelist.cz'
const SIGNIN_CALLBACK = '/signin-callback'
const SILENT_SIGNIN_CALLBACK = '/silent-signin-callback'

export const constants = {
    API_BASE_URI: 'https://api.admin.winelist.cz',

    authentication: {
        SIGNIN_CALLBACK: SIGNIN_CALLBACK,
        SILENT_SIGNIN_CALLBACK: SILENT_SIGNIN_CALLBACK,
        AUTHORITY_URI: 'https://auth.admin.winelist.cz',
        CLIENT_ID: 'js-winelist-admin',
        REDIRECT_URI: `${BASE_URI}${SIGNIN_CALLBACK}`,
        SILENT_REDIRECT_URI: `${BASE_URI}${SILENT_SIGNIN_CALLBACK}`,
        CLIENT_SECRET: 'whiMk#$26{2XXPi68GJJGnb2$v3->{',
        POST_LOGOUT_REDIRECT_URI: `${BASE_URI}/login`
    },

    LAYOUT_KEY: 'Layout',
    THEME_KEY: 'Theme',
    DEFAULT_THEME: 'white',

    REFRESH_NEEDED_ACTION: 'notifications/refreshNeeded'
}
